import { KeyControlCriteria } from '@tc-core/model/it/codegen/ui/search/criteria/key-control-criteria';
import { AbstractSearchCriteria } from './abstract-search-criteria';
import { KeyControlAndAbstractSearchCriteria } from './key-control-and-abstract-search-criteria';

export class BrandSearchCriteria extends KeyControlAndAbstractSearchCriteria {
    code: string = '';
    name: string = '';
    kcCompany: string = '';
}
